<span *ngIf="dot" class="ui-badge__dot"></span>{{ label }}
